import styled, { css } from 'styled-components'
import { padding, PaddingProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { Text } from 'Components/UI'
import { motion } from 'framer-motion'

import { LANDING_MAX_CONTENT_WIDTH_PX } from 'Constants/Landing'

export const Container = styled.div`
  position: relative;
  width: 100%;
`

export const Content = styled.div<PaddingProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${LANDING_MAX_CONTENT_WIDTH_PX}px;

  > div:last-child {
    z-index: 1;
    align-items: flex-start;
  }

  ${padding}
`

export const InvertedText = styled(Text)`
  padding-inline: ${themeGet('space.4')}px;
  background-color: ${themeGet('colors.surface.inverted')};
  color: ${themeGet('colors.text.invertedTitle')};

  .ti-cursor {
    padding-inline: ${themeGet('space.2')}px;
    font-weight: 300 !important;
    font-size: 32px !important;
  }

  @media screen and (min-width: ${themeGet('breakpoints.2')}) {
    .ti-cursor {
      font-size: 42px !important;
    }
  }
`

const backgroundCss = css`
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: 140px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 0;
  overflow: hidden;
  height: 100%;
  width: 100%;

  > svg {
    flex-shrink: 0;
    width: 550px;
    height: 645px;
  }

  @media screen and (min-width: ${themeGet('breakpoints.2')}) {
    bottom: 234px;

    > svg {
      width: 774px;
      height: 906px;
    }
  }

  @media screen and (min-width: ${themeGet('breakpoints.3')}) {
    left: unset;
    right: 0;
    bottom: 0;
    width: auto;
    transform: none;
    align-items: flex-end;

    > svg {
      transform: translateY(200px);
      width: 956px;
      height: 1120px;
    }
  }
`

export const BackgroundBase = styled(motion.div)`
  ${backgroundCss}
`

export const BackgroundAnimated = styled.div`
  ${backgroundCss};

  stroke-width: 2px;
  stroke-dasharray: 700;
  stroke-dashoffset: 700;
  animation: line 8s ease-in-out forwards;

  @keyframes line {
    to {
      stroke-dashoffset: 1;
    }
  }
`
